export function mod(divident, divisor) {
  return ((divident % divisor) + divisor) % divisor
}

export function union(set1, set2) {
  return new Set([...set1, ...set2])
}

export function intersection(set1, set2) {
  return new Set([...set1].filter(element => set2.has(element)))
}


export function checkTime(timeFrame) {
  const openTimeComponents = timeFrame.start_time.split(":");
  const openHoursToCheck = parseInt(openTimeComponents[0]);
  const openMinutesToCheck = parseInt(openTimeComponents[1]);

  const closedTimeComponents = timeFrame.end_time.split(":");
  const closedHoursToCheck = parseInt(closedTimeComponents[0]);
  const closedMinutesToCheck = parseInt(closedTimeComponents[1]);

  const currentDate = new Date();
  const currentHours = currentDate.getHours();
  const currentMinutes = currentDate.getMinutes();

  const isAfterOpen = currentHours > openHoursToCheck || (currentHours === openHoursToCheck && currentMinutes >= openMinutesToCheck);
  const isBeforeClosed = currentHours < closedHoursToCheck || (currentHours === closedHoursToCheck && currentMinutes <= closedMinutesToCheck);

  if (isAfterOpen && isBeforeClosed) {
    return { isOpen: true };
  } else if (isAfterOpen) {
    return { isOpen: false };
  } else if (currentHours === openHoursToCheck && currentMinutes >= 45) {
    return { isOpen: false, openSoon: true };
  } else {
    return { isOpen: null };
  }
}

export function FormatTime(date){
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'P.M.' : 'A.M.';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ampm;
  return strTime;
}




// WEBPACK FOOTER //
// ./src/js/util/functions/helpers.js